export type PaginationProps = {
  pagesCount: number;
};

export type ItemProps = {
  isActive: boolean;
  page: PageItem;
  currentPage: number;
  setCurrentPage: (page: number) => void;
};

export enum ItemType {
  Start = 'start',
  End = 'end',
  Dots = 'dots',
}

export type PageItem = ItemType | number;
